module.exports = __webpack_public_path__ + "img/part4-img2-1.642b0103.png";